export default {
     dateFormates:{
      short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
        daymonth:{
                year:"2-digit", month: 'long', day: 'numeric'
        },
     },

    'A Prova':'A Prova',
    'Prova':'Prova',

}